import Vue from 'vue'
import Router from 'vue-router'

import Container from '@/components/Container';

import Home from '@/pages/Home';
import Business from '@/pages/Business';
import Modao from '@/pages/Modao';
import Mohe from '@/pages/Mohe';
import Solution from '@/pages/Solution';
import Joinus from '@/pages/Joinus';
import Introduce from '@/pages/Introduce';

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Container',
      component: Container,
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },    
        {
          path: '/business',
          name: 'Business',
          component: Business
        },
        {
          path: '/modao',
          name: 'Modao',
          component: Modao
        },    
        {
          path: '/mohe',
          name: 'Mohe',
          component: Mohe
        }, 
        {
          path: '/solution',
          name: 'Solution',
          component: Solution
        },    
        {
          path: '/joinus',
          name: 'Joinus',
          component: Joinus
        },    
        {
          path: '/introduce',
          name: 'Introduce',
          component: Introduce
        },    
   
      ]
    },
  ],
  // scrollBehavior (to, from, savedPosition) {
  //   return { x: 0, y: 0 };
  // }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js